import { useContext, useEffect } from 'react'

import AddProductsButton, {
  AddProductsContext,
} from 'features/Orders/Review/components/AddProductsButton/AddProductsButton'
import { OrderData } from 'features/Orders/Review/components/Overview/Overview'

export const AddProductsNonVisible = (
  { order, onCloseModal }: AddProductsNonVisibleProps, // CHECK anotation in AddProductsButton component
) => (
  <AddProductsButton order={order} onCloseModal={onCloseModal}>
    <TextButtonContainer />
  </AddProductsButton>
)

const TextButtonContainer = () => {
  // This is an empty component that will open the Add Products modal every time it's re-rendered
  const { handleAddProducts } = useContext(AddProductsContext)

  useEffect(() => {
    handleAddProducts()
  }, [])

  return <span />
}

type AddProductsNonVisibleProps = {
  order?: OrderData
  onCloseModal: () => void
}
